import React from 'react';
import { Button, Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { ArrowLeft } from 'lucide-react';

interface BackButtonProps {
  onClick: () => void;
  destination?: string;
  tooltip?: string;
}

const StyledBackButton = styled(Button)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  color: '#00FFFF',
  borderColor: 'rgba(0, 255, 255, 0.5)',
  '&:hover': {
    background: 'linear-gradient(90deg, #003366, #00CC99, #8A2BE2, #FF6F00)',
    backgroundSize: '300% 100%',
    animation: 'gradient 6s linear infinite',
    transform: 'translateY(-2px)',
    boxShadow: '0 5px 15px rgba(138, 43, 226, 0.2)',
    border: '1px solid rgba(138, 43, 226, 0.3)',
  },
}));

const BackButton: React.FC<BackButtonProps> = ({ 
  onClick, 
  destination = 'Main View', 
  tooltip = 'Return to previous view'
}) => {
  return (
    <Tooltip title={tooltip}>
      <StyledBackButton
        variant="outlined"
        startIcon={<ArrowLeft size={16} />}
        onClick={onClick}
      >
        Back to {destination}
      </StyledBackButton>
    </Tooltip>
  );
};

export default BackButton; 